/* eslint-disable no-restricted-imports */
import { useCallback } from 'react';

import { useClientUserSendInvitationToAccountEmailMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useClientUserSendInvitationToAccountEmail = () => {
  const [handle, { data, loading, error: apolloError }] =
    useClientUserSendInvitationToAccountEmailMutation();

  const error = useError(apolloError);

  return {
    error,
    loading,
    data: data?.sendInvitationToAccountEmail,
    sendInvitationToAccountEmail: useCallback(
      async (userId: string) => {
        const res = await handle({ variables: { id: userId } });

        return {
          resendTime: res.data?.sendInvitationToAccountEmail?.resendTime,
        };
      },
      [handle]
    ),
  };
};
